import { Component, Input, OnInit } from '@angular/core';
import { each, find, forOwn, includes, map } from 'lodash';
import StudentPanelsConfig, {
  IStudentPanel,
  IStudentPanels,
  TValidStudentTypes,
} from '../../../student-container/student-panels.config';

interface IPanelDisplayItem {
  key: string;
  item: boolean;
  human: string;
}

interface IPanelMenuModel {
  [propName: string]: boolean;
}
@Component({
  selector: 'ssv-select-panels-widget',
  template: require('./ssv-select-panels-widget.component.html'),
})
export class SsvSelectPanelsWidget implements OnInit {
  @Input() currentStudent: any;
  @Input() showPanelSelectionList: boolean;

  panelMenu;
  panelConfig;

  constructor() {
    //
  }

  ngOnInit(): void {
    this.panelConfig = StudentPanelsConfig;
    let panelsForStudentType;
    if (this.currentStudent.isMS) {
      panelsForStudentType = this.getPanelsForStudentType('MS');
    } else if (this.currentStudent.isHS) {
      panelsForStudentType = this.getPanelsForStudentType('HS');
    } else {
      panelsForStudentType = this.getPanelsForStudentType('ES');
    }
    const menuModel = this.createMenuModel(panelsForStudentType);
    const menu = this.createMenu(menuModel);
    this.panelMenu = menu;
  }

  getPanelsForStudentType(studentType: TValidStudentTypes): IStudentPanel[] {
    const panelSet = [];
    each(this.panelConfig, (panel: IStudentPanel) => {
      if (includes(panel.studentTypes, studentType)) {
        panelSet.push(panel);
      }
    });
    return panelSet;
  }

  createMenuModel(panelsForStudentType: IStudentPanels): IPanelMenuModel {
    const menuModel = {};
    forOwn(panelsForStudentType, (v: IStudentPanel) => {
      menuModel[v.id] = true;
    });
    return menuModel;
  }

  createMenu(menuModel: IPanelMenuModel): IPanelDisplayItem[] {
    const menu = map(menuModel, (item, key: string) => {
      return {
        key,
        item,
        human: this.getHumanName(key),
      };
    });
    return menu;
  }

  getHumanName(key: string): string {
    return find(StudentPanelsConfig, { id: key }).human;
  }
}
